/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const i=Symbol("isSubtypeGroupGraphicOriginSymbol");function n(n){return!!n&&i in n}export{n as isSubtypeGroupGraphicOrigin,i as isSubtypeGroupGraphicOriginSymbol};
